//Author June Leow
//Date June 7th, 2024
import {getReducer, getSetStateFunction, getAPICallGenerator, postAPICallGenerator, putAPICallGenerator, deleteAPICallGenerator, callBackGenerator, formatNumber, showMessage, getSession} from '../../util/util';
import {Button,Modal, ModalHeader, ModalBody} from 'reactstrap';
import FileSaver from 'file-saver';
import MyDropzone from '../util/my-dropzone';
import React, {useReducer, useEffect} from 'react';
import '../file/file.css';
//initialize the state
const initialState = {
  appraiserFiles:[],
  toUploadFiles:[],
  bigFiles:[],
  resizeFilePopUp:false,
  modal: false,
  errorMessage:'',
  fileTypes:[],
  uploadDisabled:false
};

//reducer function that perform state update
const reducer = getReducer();


const AppraiserFile  = (props)=>{
  const controller = new AbortController();

  const [state, dispatch] = useReducer(reducer,initialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpGet = getAPICallGenerator(props, {signal:controller.signal});
  const httpPost = postAPICallGenerator(props, {signal:controller.signal});
  const httpPut = putAPICallGenerator(props, {signal:controller.signal});
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    getAppraiserFiles();
    getFileTypes();
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  useEffect(()=>{
    if(state.uploadDisabled)
      uploadAll()
  }, [state.uploadDisabled]);

  //non API call but simpyl manage state
  const buttonHandler=()=>{
    if(state.uploadDisabled)
      return;
    setState({uploadDisabled:true});
  }

  //toggle function to show and hide the file upload model
  const toggle=()=>{
    setState({
      modal: !state.modal
    });
  }

  const toggleResizeFile=()=>{
    if(state.resizeFilePopUp)
      setState({bigFiles:[]});
    setState({resizeFilePopUp: !state.resizeFilePopUp});
  }

  const removeToUploadFile = (name) => {
    const newFiles = state.toUploadFiles.filter(file => file.name !== name);
    setState({ toUploadFiles: newFiles });
  };

  const formatFileSize = (size) => {
    const intSize = parseInt(size, 10);
    if (intSize >= 1000000) {
        return formatNumber(Math.round((intSize * 10) / 1000000) / 10) + ' MB';
    } else if (intSize >= 1000) {
        return formatNumber(Math.round((intSize * 10) / 1000) / 10) + ' KB';
    } else {
        return formatNumber(intSize) + ' B';
    }
  };

  const removeFileFromList = (ID) => {
    const newAppraiserFiles = state.appraiserFiles.filter(file => file.ID !== ID);
    setState({ appraiserFiles: newAppraiserFiles });
  };

  const onFileTypeChange = (name, fileType)=>{
    for(let i=0;i<state.toUploadFiles.length;i++){
      if(state.toUploadFiles[i].name===name){
        let newToUploadFiles = [];

        for(let j=0;j<state.toUploadFiles.length;j++){
          let newFile = deepCopyFileObject(state.toUploadFiles[j]);

          if(j===i)
            newFile.fileType = fileType;

          newToUploadFiles.push(newFile);
        }

        setState({toUploadFiles:newToUploadFiles});
      }
    }
  }

  //constructing a new file object
  const deepCopyFileObject = (file)=>{
    let newFile = new File([file],file.name);
    newFile.preview = file.preview;
    newFile.fileType = file.fileType;
    newFile.status = file.status;

    return newFile
  }
    
  const onDrop = (acceptedFiles, rejectedFiles) => {
    let existingFiles = state.toUploadFiles.slice();
    let bigFiles = state.bigFiles;

    let newState = {};
    for(let i=0;i<acceptedFiles.length;i++){
      let file = acceptedFiles[i];
      file.status = 'Pending';
      file.fileType = '';

      let isBigFile = false;
      if(file.size > 40000000){
        isBigFile = true;
        bigFiles.push(file.name);
      }

      let duplicate = false;
      for(let j=0;j<state.toUploadFiles.length;j++){
        if(state.toUploadFiles[j].name===acceptedFiles[i].name){
          duplicate = true;
          newState = Object.assign({}, newState,{errorMessage:'Duplicate file name "'+acceptedFiles[i].name+'"'});
        }
      }
      if(!duplicate && !isBigFile)
        existingFiles.push(file);
    }
    if(bigFiles.length){
      newState = Object.assign({}, newState,{resizeFilePopUp:true, bigFiles:bigFiles});
    }
    newState = Object.assign({}, newState,{toUploadFiles:existingFiles});
    setState(newState);
  };

  //API call
  const downloadFile = (name) => {
    const downloadFileCallBack = (response) => {
        const code = response.data.code;
        if (code === '00') {
            const byteCharacters = atob(response.data.data);
            const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
            const byteArray = new Uint8Array(byteNumbers);
            const data = new Blob([byteArray]);
            FileSaver.saveAs(data, name);
        }
    };

    const parameters = [
        { field: 'parentFk', value: getSession().userID },
        { field: 'name', value: name },
        { field: 'directory', value: 'Appraisers' }
    ];

    httpPost('appraiser/file/download', parameters, '', `Oops, something went wrong and could not download the file "${name}". Please try again later.`, downloadFileCallBack);
};

const deleteFile = (ID) => {
    const deleteFileCallBack = (response) => {
        const code = response.data.code;
        if (code === '00') {
            removeFileFromList(ID);
        }
    };

    httpDelete('appraiser/file/' + ID, '', 'Oops, something went wrong and could not delete the file, please try again later.', deleteFileCallBack);
};

const uploadAll = () => {
  let preCheck = true;
  let errorMessage = '';
  let fileTypes = [];

  for(let i =0; i<state.toUploadFiles.length;i++){
    if(state.toUploadFiles[i].fileType && state.toUploadFiles[i].fileType===''){
      errorMessage = "One or more file type is not selected.";
      preCheck = false;
      break;
    }
  }
  console.log(preCheck);
  if (preCheck) {
      setState({ errorMessage: 'Uploading...Please do not close the window.' });
      let fileCompleted = 0;
      for(let i=0;i<state.toUploadFiles.length;i++){
        //skip file that has done upload
        if(state.toUploadFiles[i].status==='Done')
          continue;
        const reader = new FileReader();
        // eslint-disable-next-line no-loop-func
        reader.onload = () => {
            const fileAsBinaryString = reader.result;
            let base64 = btoa(fileAsBinaryString);

            let callBack = (response)=>{console.log(response);
              let code = response.data.code;

              if(code==='00'){
                //copy the array so we maintaining the immutable state
                let newToUploadFiles = [];

                //deep copy the entire file object array
                for(let j=0;j<state.toUploadFiles.length;j++){
                  let newFile;

                  try{
                    newFile = deepCopyFileObject(state.toUploadFiles[j]);

                    if(newFile.name===state.toUploadFiles[i].name)
                      newFile.status='Done';


                    newToUploadFiles.push(newFile);
                  }
                  catch(err){
                    //IE Error , not supporting file consturctor
                  }
                }

                setState({toUploadFiles:newToUploadFiles});

                //update the list of uploaded file
                setState({appraiserFiles:response.data.data}, "CONCAT_SET_STATES");
              }
              fileCompleted++;
              if(fileCompleted>=state.toUploadFiles.length){
                setState({uploadDisabled:false,errorMessage:''});
              }
            };
            
            let errorCallBack = (error)=>{
              fileCompleted++;

              if(fileCompleted>=state.toUploadFiles.length){
                setState({uploadDisabled:false,errorMessage:''});
              }
            };

            let parameters = [
              {
                field:'appraiserFk',
                value:state.typeID
              },
              {
                field:'file_type',
                value:state.toUploadFiles[i].fileType
              },
              {
                field:'upload_type',
                value:'Appraisers'
              },
              {
                field:'name',
                value:state.toUploadFiles[i].name
              }
              ,{
                field:'file_encoded',
                value:base64
              }
            ];

            httpPost('appraiser/upload', parameters, `File "${state.toUploadFiles[i].name}" uploaded successfully.`, `Oops, something went wrong and could not upload the file "${state.toUploadFiles[i].name}". Please try again later.`, callBack, errorCallBack);
        };

        reader.onabort = () => //console.log('file reading was aborted');

        reader.onerror = () => {
          showMessage('error','File upload failed, please try again later.');
        };

        reader.readAsBinaryString(state.toUploadFiles[i]);
      }
    }
    else{
      setState({errorMessage:errorMessage, uploadDisabled:false});
    }
  };

  const getAppraiserFiles = () => {
    const callBack = (response) => {
        const code = response.data.code;
        if (code === '00') {
            setState({ appraiserFiles: response.data.data });
        }
    };
    httpGet('appraiser/file/get/' + getSession().userID, '', 'Oops, something went wrong and could not load your documents. Please try again later.', callBack);
  };

  const getFileTypes = () => {
      const callBack = (response) => {
          const code = response.data.code;
          if (code === '00') {
              setState({ fileTypes: response.data.data });
          }
      };

      httpGet('appraiser/file/type/get', '', 'Oops, something went wrong and could not load file types. Please try again later.', callBack);
  };


  //render
  let appraiserFiles;
    let toUploadFiles;

    if(state.appraiserFiles.length>0){
      appraiserFiles = state.appraiserFiles.map(
        (appraisalFile, outterIndex)=>{

          return(
            <div key={outterIndex}>
              <div className="file-container">
  								<div className="font-bold">
  								<div className="display-inline cursor-pointer" ><i className="fa fa-trash red-color" onClick={()=>deleteFile(appraisalFile.ID)}></i></div><b>&nbsp;{appraisalFile.file_type}</b>
  								<br/><div className="cursor-pointer display-inline link-color" onClick={()=>downloadFile(appraisalFile.name)}><b>{appraisalFile.name}</b></div>
  							</div>
  							<font size="1"><div className="no-margin no-padding font-bold margin-top-extra"><i className="fa fa-clock-o"></i>&nbsp;{appraisalFile.datetime_created} - {appraisalFile.uploader_name}</div></font>
  						</div>
            </div>
          );
        }
      );
    }

    let filesTypesOpt;

    if(state.fileTypes.length>0){
      filesTypesOpt = state.fileTypes.map(
        (fileType, index)=>{
          return(
            <option key={index} value={fileType.name}>{fileType.name}</option>
          );
        }
      );
    }

    if(state.toUploadFiles.length>0){
      toUploadFiles = state.toUploadFiles.map(
        (file,index)=>{
          return(
            <tr key={index}>
              <td>{file.name}</td>
              <td>
                <select className="form-control" onChange={(e)=>{onFileTypeChange(file.name,e.target.value)}}>
                  <option value=""></option>
                  {filesTypesOpt}
                </select>
              </td>
              <td>{formatFileSize(file.size)}</td>
              <td><center>{file.status}</center></td>
              <td><center><i className="fa fa-times red-color cursor-pointer" onClick={()=>removeToUploadFile(file.name)}></i></center></td>
            </tr>
          );
        }
      );
    }

    let bigFileList = state.bigFiles.join(', ');

    return (
      <div>
        <div className="file-panel">
          {appraiserFiles}
        </div>
        <div className="my-diviver"></div>
        <div className="align-right">
          <br/>
          <Button color="warning" className="cursor-pointer" onClick={toggle}><i className="fa fa-plus"></i> Upload File</Button>
          <Modal className="my-modal" isOpen={state.modal} toggle={toggle} >
            <ModalHeader hidden={true} toggle={toggle}></ModalHeader>
            <ModalBody>
              <center>
                <h5><i className="fa fa-comments"></i> New file</h5>
              </center>
              <br/>

              <div>
                <MyDropzone onDrop={onDrop}/>
                <br/>
                <div className="my-divider"></div>
                <div className="small-scroll-container red-color flashit" style={{minHeight:'30px',height:'30px ',maxHeight:'30px'}}>
                  <b>{state.errorMessage}</b>
                </div>
                <div className="medium-scroll-container">
                  <table className="table file-list-table" cellSpacing="0" cellPadding="0">
                    <thead>
                      <tr>
                        <th width="30%">Name</th>
                        <th width="35%">File Type</th>
                        <th width="15%">Size</th>
                        <th width="10%"><center>Status</center></th>
                        <th width="10%">Control</th>
                      </tr>
                    </thead>
                    <tbody>
                      {toUploadFiles}
                    </tbody>
                  </table>
                </div>
                <br/>

                <center>
                  <Button color="warning" disabled={state.uploadDisabled} onClick={buttonHandler}><i className="fa fa-upload"></i> Upload</Button>&nbsp;
                  <Button color="info" onClick={toggle}>Close</Button>
                </center>
              </div>
            </ModalBody>
          </Modal>
          <Modal className="my-modal" isOpen={state.resizeFilePopUp} toggle={toggleResizeFile} >
            <ModalHeader hidden={true} toggle={toggleResizeFile}></ModalHeader>
            <ModalBody>
              <center>
                <h5><i className="fa fa-exclamation-triangle"></i> File Too Large</h5>
              </center>

              <b>Your file is larger than <font color="red">40MB</font>. Please resize your following file(s):</b>
              <div>{bigFileList}</div>

              <br/><br/>
              <center>
                <Button color="warning" onClick={toggleResizeFile}>Ok</Button>
              </center>
            </ModalBody>
          </Modal>
        </div>
      </div>
    );
}


export default AppraiserFile;
